import { forwardRef, memo, useCallback, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import Autocomplete from '@shared/components/autocomplete/Autocomplete';
import { TextField } from '@shared/views/form-dialog';

const useStyles = makeStyles((theme) => ({
  textFieldRoot: {
    height: '42px',
    width: '200px',
    "& > div.MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
      height: '42px',
      paddingRight: '50px !important',
      '& > input': {
        height: '42px',
      },
    },
  },
  valueSelected: {
    '& > div > .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '& > div > input': {
      color: theme.palette.primary.main,
    },
    '& .MuiAutocomplete-endAdornment .MuiSvgIcon-root': {
      fill: theme.palette.primary.main,
    },
  },
}));

const LANG_LIST = [
  {
    name: 'English',
    value: 'english',
  },
  {
    name: 'Russian',
    value: 'russian',
  },
];

const LangTextField = forwardRef(({
  name,
  label,
  onChange,
  value,
}, ref) => {
  const classes = useStyles();
  const options = LANG_LIST;


  const currentValue = useMemo(() => {
    if (!value) return LANG_LIST[0];
    if (typeof value === 'string') {
      return LANG_LIST.find(opt => opt.value === value.toLowerCase()) || LANG_LIST[0];
    }
    return LANG_LIST.find(opt => opt.value === value.value?.toLowerCase()) || LANG_LIST[0];
  }, [value]);

  const handleChange = useCallback((_, newValue) => {
    if (!newValue) {
      onChange(LANG_LIST[0].value);
      return;
    }

    if (typeof newValue === 'string') {
      const foundOption = LANG_LIST.find(opt => opt.name.toLowerCase() === newValue.toLowerCase() || opt.value === newValue.toLowerCase());
      onChange(foundOption ? foundOption.value : LANG_LIST[0].value);
      return;
    }
    if (newValue.value) {
      onChange(newValue.value);
      return;
    }
    onChange(LANG_LIST[0].value);
  }, [onChange]);

  return (
    <Autocomplete
      options={ LANG_LIST }
      disableClearable
      getOptionLabel={ (option) => option.name }
      isOptionEqualToValue={ (option, value) => option.value === (value?.value || value?.toLowerCase?.()) }
      onChange={ handleChange }
      ref={ ref }
      value={ currentValue }
      renderInput={ (params) => (
        <TextField
          { ...params }
          classes={ {
            root: classNames(classes.textFieldRoot, {
              [classes.valueSelected]: !!value,
            }),
          } }
          label={ label }
          variant="outlined"
        />
      ) }
    />
  );
});

export default memo(LangTextField);
